import { Button, Stack } from "@mui/material";
import React, { useState } from "react";
import CityManagement from "../CityManagement";
import StateManagment from "../StateManagement";
import DistrictManagement from "../DistrictManagement";

const SDCManagement = () => {
  const [selectedButton, setSelectedButton] = useState(null);

  const buttons = [
    { id: "state", label: "State Management" },
    { id: "district", label: "District Management" },
    { id: "city", label: "City Management" },
  ];
  const handleClick = (buttonId) => {
    setSelectedButton(buttonId === selectedButton ? null : buttonId);
  };
  const renderComponent = () => {
    switch (selectedButton) {
      case "state":
        return <StateManagment />;
      case "district":
        return <DistrictManagement />;
      case "city":
        return <CityManagement />;
      default:
        return null;
    }
  };
  return (
    <>
       <Stack spacing={2} direction="row" fullWidth>
        {buttons.map(({ id, label }) => (
          <Button
            key={id}
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: selectedButton === id ? "#006A71" : "#033538",
              color: selectedButton === id ? "white" : "#B9B9B9",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: selectedButton === id ? "#006A71" : "#006A71",
              },
            }}
            onClick={() => handleClick(id)}
          >
            {label}
          </Button>
        ))}
      </Stack>
      {renderComponent()}
    </>
  );
};

export default SDCManagement;
